var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"target":"_blank","href":_setup.props.href}},[_vm._t("default"),_vm._v(" "),_c(_setup.FontAwesomeIcon,{attrs:{"icon":"external-link-alt"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }